var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { rotateBase64 } from 'src/shared/helpers/viewsHelpers';
import { replaceInArray } from 'src/shared/helpers/objHelpers';
import { FULLSCREEN_FILE_VIEWER_MIN_ZOOM } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/FullScreenFilesViewer/constants';
export var rotateBase64ImageToLeftInArray = function (images, imageIndex) {
    var image = images[imageIndex];
    var newImage = __assign(__assign({}, image), { src: rotateBase64(image.src, false) });
    return replaceInArray(images, imageIndex, newImage);
};
export var rotateBase64ImageToRightInArray = function (images, imageIndex) {
    var image = images[imageIndex];
    var newImage = __assign(__assign({}, image), { src: rotateBase64(image.src, true) });
    return replaceInArray(images, imageIndex, newImage);
};
export var calculatePositionByScaleAndMousePosition = function (event, newScale) {
    var width = event.target.offsetWidth;
    var height = event.target.offsetHeight;
    // get the ratio between the image size and the image size with transform
    var ratioWithTransform = newScale * (1 / (0.5 * (newScale - 1)));
    // get the max range of content offset
    var xDifferenceOnScale = width / ratioWithTransform;
    var yDifferenceOnScale = height / ratioWithTransform;
    var xIntervalAfterScale = event.nativeEvent.offsetX / width;
    var yIntervalAfterScale = event.nativeEvent.offsetY / height;
    var xObjectPosition = xDifferenceOnScale - xIntervalAfterScale * (2 * xDifferenceOnScale);
    var yObjectPosition = yDifferenceOnScale - yIntervalAfterScale * (2 * yDifferenceOnScale);
    return { scale: newScale, position: { x: xObjectPosition, y: yObjectPosition } };
};
export var setTransformStyle = function (scale, position) {
    return "scale(".concat(scale, ") translate(").concat(position.x, "px, ").concat(position.y, "px)");
};
export var getTransformProperties = function (transformStyle) {
    if (!transformStyle) {
        return {
            scale: FULLSCREEN_FILE_VIEWER_MIN_ZOOM,
            position: { x: 0, y: 0 },
        };
    }
    var _a = transformStyle.split('translate'), scale = _a[0], position = _a[1];
    var _b = position.replace('(', '').replace(')', '').replace('px', '').split(','), x = _b[0], y = _b[1];
    return {
        scale: Number.parseInt(scale.replace('scale(', ''), 10),
        position: { x: Number.parseInt(x, 10) || 0, y: Number.parseInt(y, 10) || 0 },
    };
};
